import { Flex, DataList } from '@volue/wave-react';
import React from 'react';

import { useAppState } from '@/overmind';

import type { SelectedGridElement } from '../../../overmind/calculation';
import { EvaluatedResultComponent } from '../../EvaluatedResultComponent';
import { LoadFlowDetailsHeader } from './LoadFlowDetailsHeader';

type SelectedAcLineSegment = {
  type: 'SELECTED_GRID_ELEMENT';
  gridElement: SelectedGridElement<'AcLineSegment'>;
};

export const ACLineDetails: React.FunctionComponent<{
  acline: SelectedAcLineSegment;
}> = ({ acline }) => {
  const isNewPropertiesForAcLineSegmentEnabled =
    useAppState().featureToggles?.isNewPropertiesForAcLineSegmentEnabled;

  return (
    <span data-component={ACLineDetails.name} style={{ display: 'contents' }}>
      {acline.gridElement.loadflow.type === 'LOAD_FLOW_DETAILS' && (
        <Flex flow="column" gap={'spacingXs'}>
          <LoadFlowDetailsHeader
            scenarioName={acline.gridElement.loadflow.details.scenarioName}
          />
          {isNewPropertiesForAcLineSegmentEnabled && (
            <DataList className="mHxl">
              <Flex as={DataList.Row} main="space-between">
                <DataList.Label>{'Rated Current '}</DataList.Label>
                <Flex main={'end'} as={DataList.Value}>
                  {acline.gridElement.loadflow.details.inputs.ratedCurrent.toString(
                    { numberOfDigits: 2 }
                  )}
                </Flex>
              </Flex>

              <Flex as={DataList.Row} main="space-between">
                <DataList.Label>{'Current'}</DataList.Label>
                <Flex main={'end'} as={DataList.Value}>
                  <EvaluatedResultComponent
                    result={acline.gridElement.loadflow.details.results.current}
                    numberOfDigits={2}
                  />
                </Flex>
              </Flex>
              <Flex as={DataList.Row} main="space-between">
                <DataList.Label>{'Loading'}</DataList.Label>
                <Flex main={'end'} as={DataList.Value}>
                  <EvaluatedResultComponent
                    result={
                      acline.gridElement.loadflow.details.results.loadingPercent
                    }
                    numberOfDigits={2}
                  />
                </Flex>
              </Flex>
              <Flex as={DataList.Row} main="space-between">
                <DataList.Label>{'Available Capacity'}</DataList.Label>
                <Flex main={'end'} as={DataList.Value}>
                  <EvaluatedResultComponent
                    result={
                      acline.gridElement.loadflow.details.results
                        .availableCapacity
                    }
                    numberOfDigits={2}
                  />
                </Flex>
              </Flex>
            </DataList>
          )}
          {!isNewPropertiesForAcLineSegmentEnabled && (
            <DataList className="mHxl">
              <Flex as={DataList.Row} main="space-between">
                <DataList.Label>{'Loading'}</DataList.Label>
                <Flex main={'end'} as={DataList.Value}>
                  <EvaluatedResultComponent
                    result={
                      acline.gridElement.loadflow.details.results.loadingPercent
                    }
                  />
                </Flex>
              </Flex>
            </DataList>
          )}
        </Flex>
      )}
    </span>
  );
};
